import React, { useState } from 'react'
import { Drawer } from 'antd'
import { Link, Route, Switch, useHistory, useParams } from 'react-router-dom'

import { useToggle, usePet, stringifyDate } from '../../modules'

import Receive from './receive'
import { EntryFields } from './inputs'

import PatientDetails from './patient'

const Entry = ({ document, onClose, title, path }) => {
    const [entry, setEntry] = useState()

    const history = useHistory()
    const { id } = useParams()

    const [visible, toggleVisible] = useToggle(true)

    const [{ loading: eLoading, error: eError }, getEntry] = usePet(document ? 'singleEntry' : 'singleEntryFromOrderItem', { id }, { notify: true, callback: ({ data }) => setEntry(data) })

    const reload = () => {
        setEntry()
        getEntry()
    }

    const close = () => {
        toggleVisible()
        setTimeout(() => history.goBack(), 300)
    }
    
    const [{ loading: compLoading }, completeEntry] = usePet('completeEntry', { id: entry }, { notify: true, callback: (_, notif, ops) => {
        notif('Changes have been saved', ops('success'))
        onClose()
        close()
    }, manual: true, load: { msg: 'Saving changes...' } })

    return (
        <Drawer
            closable
            maskClosable
            visible={visible}
            onClose={close}
            footer={
                <div className="w-full text-right">
                    <button onClick={ completeEntry } disabled={ compLoading } className="text-white mr-2 hisani-btn-orange font-medium rounded-lg text-sm px-5 py-2.5 text-center">{ entry?.filled ? 'Update' : 'Complete' }</button>
                    <Link to={`${ document?.path ?? path}/${id}/${entry?.patient?._id}`}>
                        <button className="text-white mr-2 hisani-btn-orange font-medium rounded-lg text-sm px-5 py-2.5 text-center">Patient Details</button>
                    </Link>
                    <button onClick={ close } className="text-white mr-2 bg-gray-500 hover:bg-gray-600 focus:ring-4 focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center">Close</button>
                </div>
            }
            width="40%">
            <p className="font-extrabold text-3xl mb-0">{ document?.title ?? title }</p>
            <Receive
                progress
                loading={eLoading}
                error={eError}>
                {
                    entry ?
                        <>
                            <p className="text-gray-500 text-xs italic">{entry?.patient?.name ?? 'Patient'}'s entry {entry?.date && `on ${stringifyDate(entry.date)}`}</p>
                            {
                                <EntryFields
                                    reload={ reload }
                                    entry={entry}
                                    fields={entry?.item?.fields ?? []} />
                            }
                        </>
                        : null
                }
            </Receive>
            <Switch>
                <Route path={ `${ document?.path ?? path}/:id/:pat` }>
                    <PatientDetails attachedTo={entry?._id} reload={ getEntry } />
                </Route>
            </Switch>
        </Drawer>
    )
}

export default Entry